"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useEffect, useState } from "react";
type HeaderTheme = "light" | "dark";
const HeaderThemeContext = createContext<{
  theme: HeaderTheme;
  setTheme: (theme: HeaderTheme) => void;
}>({
  theme: "light",
  setTheme: () => undefined
});
export function HeaderThemeProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [theme, setTheme] = useState("light");
  let t1;
  if ($[0] !== theme) {
    t1 = {
      theme,
      setTheme
    };
    $[0] = theme;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <HeaderThemeContext.Provider value={t1}>{children}</HeaderThemeContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}

/**
 * Use `"dark"` if the page has a dark background behind the header on initial load.
 * The header will automatically revert to dark colors once the frosted glass appears.
 */
export function useHeaderTheme(theme) {
  const $ = _c(4);
  const {
    setTheme
  } = useContext(HeaderThemeContext);
  let t0;
  let t1;
  if ($[0] !== setTheme || $[1] !== theme) {
    t0 = () => {
      setTheme(theme);
      return () => setTheme("light");
    };
    t1 = [theme, setTheme];
    $[0] = setTheme;
    $[1] = theme;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}
export function useHeaderThemeValue() {
  return useContext(HeaderThemeContext).theme;
}